export enum ArtistTableColumn {
	NAME = 'name',
	UPC = 'upc',
	EDIT = 'edit',
	DELETE = 'delete',
}
